// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"f1e60347","60":"05d39660","120":"d1430a7c","244":"1db068f0","315":"ca04725c","348":"c819833e","349":"998406d5","352":"dc39af3c","431":"1b09aa6b","444":"d907d85d","453":"66b26d51","598":"293272d2","675":"706947b2","840":"20c7ab93","894":"db946a3f","951":"32925b0f"}[chunkId] + ".chunk.js";
};